export default "__VITE_ASSET__588630bd__"